import { SiteUtilities } from '../utils';

const fworksCrmSignupForm = function (form, response) {
  const $form = $(form);
  const firstName = $form.find('.first-name-form').val() || null;
  const lastName = $form.find('.last-name-form').val() || null;
  const email = $form.find('input[name^="email"]').val() || null;
  const emailHash = SiteUtilities.getShaHash(email);
  const domain = $form.find('.domain-form').val() || null;
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();

  const redirect = $form.data('redirect');
  const redirectAds = $form.data('redirect-ads');
  const productDesign = $form.hasClass('product-signupform');
  const userAgent = SiteUtilities.getUserAgentForMobile();

  fworksCrmSignupFormSuccess($form, true);
  const signupResponse = response['product_signup_response'];
  const redirectUrl = signupResponse['redirect_url'].replace(/\/$/, '');

  if (productDesign) {
    if (!userAgent.length) {
      window.location.href = redirectUrl;
    }
  }
  if (!productDesign) {
    // Send data to google analytics
    try {
      var trackers = ga.getAll();
      for (var t = 0; t < trackers.length; t++) {
        if (trackers[t].get('trackingId') === 'UA-78569416-1') {
          var trackerName = trackers[t].get('name');
          ga(trackerName + '.set', {
            page: `${SiteUtilities.removeTrailingSlashEnd(window.location.href)}/thank-you/?redirect=${redirectUrl}&ehash=${emailHash}`,
            title: 'Signup Complete',
            dimension1: domain + '.freshsales.io',
            dimension8: SiteUtilities.sanitizeGACookie(SiteUtilities.getGAClientID())
          });
          ga(trackerName + '.send', 'pageview', {
            page: `${SiteUtilities.removeTrailingSlashEnd(window.location.href)}/thank-you/?redirect=${redirectUrl}&ehash=${emailHash}`,
            title: 'Signup Complete'
          });
          break;
        }
      }
    } catch (e) {
      console.log(e);
    }

    // Code to add a param to the thank-you page for referral program sign-ups
    const utmSource = SiteUtilities.getParameterByName('utm_source');
    let referralParam = '';
    if (utmSource && utmSource === 'invitereferrals') {
      referralParam = '&referral_sign_up=' + encodeURIComponent('true') + '&email=' + encodeURIComponent(email) + '&username=' + encodeURIComponent(firstName + ' ' + lastName);
    }

    const planName = SiteUtilities.getParameterByName('plan');
    // Storing the redirect url locally to avoid XSS from url.
    (planName && planName !== '') ? localStorage.setItem('redirect_url', redirectUrl + '?plan=' + planName) : localStorage.setItem('redirect_url', redirectUrl);

    // Code to add a param to the thank-you page for plan-signups (PL-ADS)
    let thankYouRedirect;
    if (planName && planName !== '') {
      const planParam = '&plan=' + encodeURIComponent(planName);
      thankYouRedirect = `${redirectAds}/?${planParam}&redirect=${encodeURIComponent(redirectUrl)}${planParam}${referralParam}&ehash=${emailHash}`;
    } else {
      thankYouRedirect = `${redirect}/?redirect=${encodeURIComponent(redirectUrl)}${referralParam}&ehash=${emailHash}`;
    }
    if (isExternalIframeSignup) {
      thankYouRedirect = thankYouRedirect + '&post_to_partner=true';
      if (currentReferrer) {
        thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
      }
    }
    window.location.href = thankYouRedirect;
  }
};

const fworksCrmSignupFormSuccess = ($form, success) => {
  const productDesign = $form.hasClass('product-signupform');
  const $thankYouCard = $form.closest('.product-form-wrapper').find('.thank-you-card');
  const $submitButton = $form.find('.button');
  if (productDesign) {
    $('html, body').animate({ scrollTop: 0 }, 0);
    $form.parent('.product-form-container').addClass('active');
    $thankYouCard.addClass('active');
    $submitButton.removeClass('button--product-disabled').removeAttr('disabled');
  }
  if (success) {
    if (productDesign) {
      $thankYouCard.find('.product-form-success').removeClass('hide');
      $thankYouCard.find('.product-form-failure').addClass('hide');
    }
  } else {
    if (productDesign) {
      $thankYouCard.find('.product-form-success').addClass('hide');
      $thankYouCard.find('.product-form-failure').removeClass('hide');
    } else {
      $submitButton.removeClass('button--loading').val('Retry').removeAttr('disabled');
    }
  }
};

export default {
  fworksCrmSignupForm,
  fworksCrmSignupFormSuccess
};
